import React from 'react';
import { IntakeList } from '@/components/intakes/IntakeList';

export function IntakesPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <IntakeList />
    </div>
  );
}